// eslint-disable-next-line
import { injectable } from "inversify";
import { IApiKey, IIntegration } from "../../models/IntegrationsTypes";
import { IFetchListArgs, IPagedData } from "../../stores/abstract-paged-data-store";
import { TYPE, rootContainer } from '../container/root';
import { createPagedRequestURLSearchParams } from "../helpers";
import { IApiResponse, IHttpService } from "../http-service";
import { WithOld } from "../../stores/types";

export interface IReturngoApiService {}

export interface IApiKeysPagedList {
    is_public_api_enabled: boolean;
    list: IPagedData<IIntegration>;
}


@injectable()
class ReturngoApiService implements IReturngoApiService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchList(args: IFetchListArgs): Promise<IApiKeysPagedList> {
        const { page, perPage, sortBy, sortDir } = args;
        const searchParams = createPagedRequestURLSearchParams(page, perPage, sortBy, sortDir);
        const res = await this.httpService.get<IApiResponse<IApiKeysPagedList>>(`/rms-api/api-keys/list?${searchParams.toString()}`);
        return res.payload;
    }

    async fetchApiKey(integrationsConnectionId: number): Promise<IIntegration> {
        const res = await this.httpService.get<IApiResponse<IIntegration>>(`/rms-api/api-keys/${integrationsConnectionId}`);
        return res.payload;
    }

    async updateApiKey(integrationsConnectionId: number, data: WithOld<IApiKey>): Promise<IIntegration> {
        const res = await this.httpService.put<IApiResponse<IIntegration>>(`/rms-api/api-keys/${integrationsConnectionId}`, data);
        return res.payload;
    }

    async removeApiKey(integrationsConnectionId: number): Promise<IIntegration> {
        const res = await this.httpService.remove<IApiResponse<IIntegration>>(`/rms-api/api-keys/${integrationsConnectionId}`);
        return res.payload;
    }

    async addApiKey(): Promise<IIntegration> {
        const res = await this.httpService.post<IApiResponse<IIntegration>>('/rms-api/api-keys');
        return res.payload;
    }
}

export default ReturngoApiService;
